import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

import { EnvUtil } from '../../utils/env-util';

import { EngagementsViewInterviewDetails } from './EngagementsViewInterviewDetails';

export type EngagementsViewStateBannerInterviewingConfirmedProps = {
  engagement: CandidateEngagementDetails;
  interview: CandidateEngagementDetails['interviews'][number];
  name?: string;
};

export const EngagementsViewStateBannerInterviewingConfirmed: React.FC<
  EngagementsViewStateBannerInterviewingConfirmedProps
> = ({
  engagement,
  interview,
  name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_CONFIRMED',
}) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERVIEWING_CONFIRMED_HEADER">
          Next Step: Prepare for your interview
        </ParagraphHeader>
        <Paragraph name="INTERVIEWING_CONFIRMED_MESSAGE_1">
          Your interview is confirmed. Go ahead and start preparing for your
          interview using{' '}
          <a href={EnvUtil.interviewGuideUrl} rel="noreferrer" target="_blank">
            Axiom's Interview Preparation Guidelines
          </a>
          .
        </Paragraph>
        {engagement.opportunity.ownerUser ? (
          <Paragraph name="INTERVIEWING_CONFIRMED_MESSAGE_2">
            Questions about interview details or have last-minute issues? Reach
            out to the opportunity contact{' '}
            <a href={`mailto:${engagement.opportunity.ownerUser.email}`}>
              {engagement.opportunity.ownerUser.fullName}
            </a>
            .
          </Paragraph>
        ) : null}
        <EngagementsViewInterviewDetails
          interview={interview}
          name="ENGAGEMENT_VIEW_INTERVIEW_DETAILS"
        />
      </Layout>
    </Banner>
  );
};
